<template>
  <div style="height: 100%; overflow-y: auto; overflow-x: hidden">
    <a-tree
      v-if="treeData.length>0"
      :tree-data="treeData"
      :expandedKeys="expandedKeys"
      :selectedKeys="selectedKeys"
      :replaceFields="{children:'children', title: 'name', key: 'code'}"
      @expand="onExpand"
      @select="selectTree"
    />
  </div>
</template>

<script>
import { RegionServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import { CustomerServiceProxy } from '@/service-proxies/app-v2/client.service-proxies'
import {CustomerServiceProxy as mccsp } from "@/service-proxies/app-v2/masterlink-cps-client.service-proxies"
const rsp = new RegionServiceProxy()
const csp = new CustomerServiceProxy()
const api = new mccsp();
import { getTenantInfo } from '@/utils/auth'

export default {
  data() {
    return {
      treeData: [],
    }
  },
  props: {
    selectedKeys: Array,
    expandedKeys: Array,
  },
  created() {
    this.getTreeList()
  },
  methods: {
    async getTreeList() {
      const tenant = getTenantInfo()
      const tenantCode = tenant ? tenant : '根节点'
      const treeData = [
        {
          code: 'un-00',
          name: '未出库机床',
          id: 'un-00',
          key: 'un-00',
          isLeaf: true,
          isProv: false,
        },
        {
          code: '00-00',
          id: '00-00',
          key: '00-00',
          name: tenantCode,
          isLeaf: false,
          isProv: false
        }
      ]
      const { data } = await api.getRegionCustomerDetail();
      treeData[1].children = data;
      this.treeData = treeData;
      this.$emit('getTreeData', this.treeData);
    },
    selectTree(value, row) {

      if (value.length === 0) {
        return
      }
      if (value[0] === 'un-00') {
        this.$emit('changeUnCustomer', 'un-00')
      } else {
        console.log(value,row)
        this.$emit('changeCustomer', {key: value, data: row.node.dataRef})
      }
    },
    onExpand(expandKeys, {expanded, node}) {
     this.$emit('setExpandKeys', expandKeys);
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
  width: 100%;
  background-color: #fff1b8;
}
/deep/ .ant-tree li .ant-tree-node-content-wrapper {
  width: 100%;
}
</style>
